import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TEXT from "../../../../utils/globalText";
// Component

import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import useCategories from "../../../../utils/useCategories";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { reimbursementTxnRequestSuccessDetail } from "../../../../redux/features/reimbursementTransaction";
import accountNameStandardised from "../../../../utils/accountNamestandardised";

const ReimbursementTxnSuccessPage = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    reimbursementTxnSuccessRequestData,
    reimbursementTxnSuccessRequestLoading,
  } = useSelector((state) => state.reimbursementTransaction);

  const categoryMapper = useCategories();
  const location = useLocation();
  const Requestlocation = location?.state;

  useEffect(() => {
    dispatch(disableSwitcher());
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(reimbursementTxnRequestSuccessDetail(id));
  }, [id]);

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${reimbursementTxnSuccessRequestData?.request?.[0]?.beneficiary_transactions_details?.beneficiary_transaction_id}`,
    );
  };

  const createAccountHandler = () => {
    navigate(
      "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
    );
  };

  const dashboardHandler = () => {
    navigate("/reimbursement_transaction_dashboard");
  };

  // Button

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  const RequestbuttonRows = [
    [
      {
        btnText: "View request details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: () =>
          navigate(
            `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${Requestlocation?.Request_id}`,
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View transaction details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: () => {
          navigate(
            `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${reimbursementTxnSuccessRequestData?.request?.[0]?.beneficiary_transactions_details?.beneficiary_transaction_id}`,
          );
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      // {
      //   btnText: "View details",
      //   enabledBgColor: "var(--text-primary)",
      //   enabledTextColor: "var(--positive-bg)",
      //   icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
      //   handleFunction: viewDetailsHandler,
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   imgColor: "var(--positive-bg)",
      // },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  return (
    <>
      <StatusContainer
        isLoading={reimbursementTxnSuccessRequestLoading}
        status="success"
        hoverOption="white"
        title={`${
          Requestlocation?.type === "PayReimburseTxn"
            ? "Request approved and transaction created successfully."
            : "Reimbursement transaction created successfully."
        }`}
        buttonRows={
          Requestlocation?.type === "PayReimburseTxn"
            ? RequestbuttonRows
            : buttonRows
        }
      >
        <TabsWeapperSection title="Request details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountNameStandardised(
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.beneficiary_account_name,
                  ),
                  leftSubTitle: "Account name",
                  hasRight: true,
                  rightText: true,
                  rightTitleTextColor: "var(--text-primary)",
                  rightTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          reimbursementTxnSuccessRequestData?.request[0]
                            ?.requested_amount
                        }
                      />
                    </>
                  ),
                  rightTextFontWeight: "semibold",
                  rightSubTitle: "Amount",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={() =>
                navigate(
                  `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${reimbursementTxnSuccessRequestData?.request[0]?.beneficiary_account_id}`,
                )
              }
              //   handleFunction={}
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.beneficiary_account_bank_acc_no,
                  ),
                  leftSubTitle: TEXT?.DESTINATION_ACCOUNT_NUMBER,
                  ifsc: reimbursementTxnSuccessRequestData?.request[0]
                    ?.beneficiary_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
              hoverable="black"
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    reimbursementTxnSuccessRequestData?.request[0]?.category,
                  leftSubTitle: "Transaction category",
                  icon: categoryMapper(
                    reimbursementTxnSuccessRequestData?.request[0]?.category,
                  ),
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={() =>
                navigate(
                  `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${reimbursementTxnSuccessRequestData?.request[0]?.owner_account_id}`,
                )
              }
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: TEXT?.SOURCE_ACCOUNT_NUMBER,
                  ifsc: reimbursementTxnSuccessRequestData?.request[0]
                    ?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
              hoverable="black"
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default ReimbursementTxnSuccessPage;
